<footer class="main-footer padding-inline-1">
  <span>Copyright <em nz-icon nzType="copyright" (click)="checkVersion()" (dblclick)="onChangeIsUpdateAvailable(true)"></em> {{ year }}
    All rights reserved to <a class="underlined-link-button" target="_blank" href="https://nexxen.com/" rel="noopener noreferrer">Nexxen International</a> Ltd</span>
  <div class="terms-and-conditions">
    <a class="underlined-link-button" (click)="toggleTermsModal('tos')">Terms of Service</a>
    <a class="underlined-link-button" (click)="toggleTermsModal('dpa')">Data Processing Addendum</a>
  </div>
</footer>

<!-- terms of service modal -->
<nz-modal [(nzVisible)]="isShowTermsModal" [nzTitle]="modalTitle" [nzContent]="modalContent"
  [nzFooter]="modalFooter" (nzOnCancel)="toggleTermsModal(termsModalType)" nzWidth="'75%'">
  <ng-template #modalTitle>
    {{termsModalTitle[termsModalType]}}
  </ng-template>
  <ng-template #modalContent>
    <div *ngIf="termsModalContent[termsModalType]" [innerHTML]="termsModalContent[termsModalType] | sanitizer: 'html'"></div>
  </ng-template>
  <ng-template #modalFooter>
    <button nz-button nzType="primary" class="primary-button" (click)="toggleTermsModal(termsModalType)">OK</button>
  </ng-template>
</nz-modal>
